import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column pl-2 pr-2" }
const _hoisted_2 = { class: "mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "" }, "OBJEDNÁVKY", -1)
const _hoisted_4 = { class: "flex justify-content-end" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Column = _resolveComponent("Column")!
  const _component_PrimevueTag = _resolveComponent("PrimevueTag")!
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_router_link, { to: "/mod-orders/order/0" }, {
          default: _withCtx(() => [
            _createVNode(_component_PrimevueButton, {
              label: "Pridať objednávku",
              severity: "success",
              icon: "pi pi-plus",
              text: "",
              raised: "",
              class: "uppercase"
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_DataTable, {
        rowStyle: $options.rowStyle,
        lazy: "",
        paginator: "",
        rows: this.pagination.rows,
        onPage: $options.onPage,
        first: this.pagination.first,
        loading: $data.loading,
        totalRecords: this.pagination.totalRecords,
        dataKey: "id",
        value: this.orders,
        filters: $data.filters,
        "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (($data.filters) = $event)),
        onFilter: $options.onFilter,
        filterDisplay: "row",
        globalFilterFields: $data.globalFilterFields,
        stripedRows: "",
        "row-hover": "",
        selection: this.selectedOrder,
        "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => ((this.selectedOrder) = $event)),
        selectionMode: "single",
        metaKeySelection: false,
        onRowSelect: _cache[3] || (_cache[3] = ($event: any) => ($options.showDetail(this.selectedOrder.id))),
        tableStyle: "min-width: 50rem",
        virtualScrollerOptions: { itemSize: 40 }
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_IconField, { iconPosition: "left" }, {
              default: _withCtx(() => [
                _createVNode(_component_InputIcon, null, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode(_component_InputText, {
                  modelValue: $data.filters['global'].value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.filters['global'].value) = $event)),
                  placeholder: "Vyhľadať",
                  onKeydown: _withKeys($options.onFilter, ["enter"])
                }, null, 8, ["modelValue", "onKeydown"])
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "orderCode",
            header: "ID",
            filterField: "orderNumber",
            showFilterMenu: false,
            filterMenuStyle: { width: '6rem' },
            style: {"min-width":"12%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.orderCode), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_InputText, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                type: "text",
                onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                class: "p-column-filter",
                placeholder: "Hľadať",
                style: {"min-width":"6rem"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "customerName",
            header: "Zákazník",
            filterField: "customerName",
            showFilterMenu: false,
            filterMenuStyle: { width: '8rem' },
            style: {"min-width":"12%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.customerName), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_InputText, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                type: "text",
                onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                class: "p-column-filter",
                placeholder: "Hľadať",
                style: {"min-width":"10rem"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Popis",
            field: "description",
            style: {"min-width":"6%"}
          }),
          _createVNode(_component_Column, {
            field: "state",
            header: "Status",
            showFilterMenu: false,
            filterMenuStyle: { width: '2rem' },
            style: {"min-width":"2rem"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.state), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_PrimevueSelect, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                onChange: ($event: any) => (filterCallback()),
                options: $data.statusLabels,
                optionLabel: "label",
                placeholder: "Vyber stav",
                class: "p-column-filter",
                style: {"min-width":"6rem"}
              }, {
                option: _withCtx((slotProps) => [
                  _createVNode(_component_PrimevueTag, {
                    value: slotProps.option.label,
                    style: _normalizeStyle({ backgroundColor: slotProps.option.color })
                  }, null, 8, ["value", "style"])
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Neprečítané správy",
            field: "unreadMessages",
            style: {"min-width":"6%"}
          }),
          _createVNode(_component_Column, {
            header: "Dátum",
            style: {"width":"18%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString($options.formatDate(slotProps.data.createdAt)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "" }, {
            body: _withCtx((slotProps) => [
              _withDirectives(_createVNode(_component_PrimevueButton, {
                type: "button",
                icon: "pi pi-trash",
                onClick: ($event: any) => ($options.confirmDelete(slotProps.data.id)),
                text: "",
                severity: "danger",
                size: "small"
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  { value: 'Vymazanie objednávky' },
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rowStyle", "rows", "onPage", "first", "loading", "totalRecords", "value", "filters", "onFilter", "globalFilterFields", "selection"])
    ]),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}